import React from 'react';

import { Text } from '@lumapps/lumx/react';

import { findMatchesInText } from '../../utils/findMatchesInText';

interface HighlightedTextProps {
    text: string;
    query?: string;
}

/**
 * Display matching parts of the given query within the text in bold.
 *
 * The visual split into strong/span segments is hidden from assistive tech via `aria-hidden`,
 * with the full original text exposed through `aria-label` on the wrapper so screen readers
 * announce it as one continuous word/phrase instead of pausing at segment boundaries.
 */
export function HighlightedText({ text, query }: HighlightedTextProps) {
    if (!text) {
        return '';
    }
    const segments = findMatchesInText(text, query || '');
    return (
        <Text as="span" aria-label={text}>
            {segments.map(({ index, str, matches }) => {
                const Element = matches ? 'strong' : 'span';
                return (
                    <Element key={index} aria-hidden="true">
                        {str}
                    </Element>
                );
            })}
        </Text>
    );
}
